import createCollectionStore from '../create';
import { fetchAllPendingProductInstance, setDeclinedForPendingProductInstance } from '../../core-data';

export default createCollectionStore(
  'PendingProductInstance',
  () => fetchAllPendingProductInstance(),
  'hexObjectId',
  [],
  {
    decline: async (state, actions, pendingProductInstance, declined = false) => {
      await setDeclinedForPendingProductInstance(pendingProductInstance.hexObjectId, declined);
      await actions.updateCache({
        ...pendingProductInstance,
        declined: declined
      });
      return { };
    }
  }
);


// WEBPACK FOOTER //
// ./src/services/collection/collections/pending-product-instance.js